
import PasswordModal from "@/components/setup/PasswordModal.vue";
import SetupSidebar from "@/components/setup/SetupSidebar.vue";

export default {
    components: { PasswordModal, SetupSidebar },
    name: 'index',
    middleware: 'userAuth',
    data() {
        return {
            value: true,
            account: false,
            account_sub: 0,
            activeName: 'first',
            passwordModalVisible: false,
            user_score_log: '',
            userInfo: {},
            currentPage: 1,
            type: 1,
            loading: false
        };
    },
    methods: {
        handleAccount() {
            this.account = !this.account
            this.account_sub = 0
        },
        /** 内容区点「修改密码」时同步 URL，刷新可保留 */
        openPasswordPanel() {
            this.account_sub = 2
            if (this.$route.query.sub !== 'password') {
                this.$router.replace({ path: '/setup', query: { sub: 'password' } }).catch(() => {})
            }
        },
        handleClick(tab, event) {

            this.currentPage = 1
            this.user_score_log = []

            let index = Number(tab.index)
            index += 1
            this.type = index
            console.log(index);
            this.handUserInfoRecord(this.currentPage, index)
        },
        async handUserInfoRecord(page = 1, type = 1) {
            this.loading = true
            const res = await this.$global.userinfoRecord({ "page": page, "type": type })
            if (res.code == 200) {
                this.user_score_log = res.data.user_score_log
                this.userInfo = { ...this.userInfo, ...res.data.user_info }
                this.loading = false
            }
        },
        onPasswordSuccess() {
            // 密码创建成功后刷新 is_password 状态
            this.userInfo = { ...this.userInfo, is_password: 1 }
        },
        // 点击页码
        async handleCurrentChange(val) {
            this.currentPage = val

            this.handUserInfoRecord(this.currentPage, this.type)

        },
        syncAccountSubFromRoute() {
            if (this.$route.query.sub === 'password') {
                this.account_sub = 2
            } else if (this.account_sub === 2) {
                this.account_sub = 0
            }
        },
    },
    mounted() {
        // 兼容旧链接 /setup?tab=blacklist
        if (this.$route.query.tab === 'blacklist') {
            this.$router.replace({ path: '/setup/blacklist' }).catch(() => {})
            return
        }
        this.syncAccountSubFromRoute()
        this.userInfo = { ...this.$store.state.userInfo.userInfo }
        this.handUserInfoRecord()
    },
    watch: {
        '$route.query.sub'() {
            this.syncAccountSubFromRoute()
        },
    },

}
